import { put, call, takeEvery } from 'typed-redux-saga';

import DiscountGateway from '~apis/discount';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { DiscountStatusEnum, TransactionActionEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetDiscountsSettings(api: DiscountGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingGetDiscountsAttempt', handleGetDiscountsSettings, api);
}

function* handleGetDiscountsSettings(api: DiscountGateway) {
    const reduxState = store.getState();

    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            discountName,
            discountCode,
            transactionType,
            status,
        },
    } = reduxState.setting.discounts;

    if (!index && index !== 0) {
        yield put(combinedActions.settingGetDiscountsFailure(ErrorMessages.GenericRequiredFieldNotProvided));
        return;
    }

    const response = yield* call([api, api.getDiscountsSettings], {
        authToken,
        index,
        discountName: discountName || undefined,
        discountCode: discountCode || undefined,
        discountType: transactionType ? UtilFunctions.Misc.getEnumValueByKey(TransactionActionEnum, transactionType) : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(DiscountStatusEnum, status) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingGetDiscountsFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingGetDiscountsSuccess(response.data));
    }
}
